import { html } from '@design.estate/dees-element';

export const demoFunc = () => html`
  <style>
    .reasoningDemo {
      display: grid;
      gap: 16px;
      max-width: 640px;
      margin: 40px auto;
      padding: 24px;
      border-radius: var(--dees-radius-xl);
      background: var(--dees-color-bg-secondary);
    }
  </style>
  <div class="reasoningDemo">
    <dees-harness-reasoning
      .reasoningPart=${{
        id: 'r1',
        text: 'The user wants a summary of the failing test. I should read the test output first, then check the assertion that failed and compare with the fixture data.',
        startedAt: Date.now() - 4200,
        endedAt: Date.now(),
      }}
    ></dees-harness-reasoning>
    <dees-harness-reasoning
      .reasoningPart=${{
        id: 'r2',
        text: 'Considering the tradeoffs between the two migration paths',
        startedAt: Date.now() - 1500,
      }}
    ></dees-harness-reasoning>
  </div>
`;
